export default function EmerestAndRoyal() {
  return (
    <div className="bg-gradient-to-b from-slate-100 to-royalBlue">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-4 p-4 max-w-screen-xl mx-auto">
        {/* Horizontal Text Box - Move this BELOW the first horizontal image to appear on second row */}
        <div className="col-span-1 sm:col-span-2 lg:col-span-2 row-span-1 aspect-video bg-white rounded-2xl shadow-md p-6 flex items-center justify-center text-center lg:grid-cols-2">
          <div>
            <h1 className="text-royalBlue text-xl pt-2 font-semibold">
              📷 Professional Photography That Elevates Your Brand
            </h1>
            <p className="text-m text-gray-800">
              With a proven track record working with clients like Emerest and
              Royal Care, we specialize in creating striking, high-quality
              images that tell your company’s story. Whether it’s corporate
              portraits, product photography, or event coverage, our work helps
              businesses stand out in their marketing materials and online
              presence.
            </p>
          </div>
        </div>

        {/* Vertical Image */}
        <div className="col-span-1 sm:col-span-1 lg:col-span-2 row-span-1 bg-gray-100 rounded-2xl shadow-md sm:col-span-2 ">
          <img
            src="../Imgs/EmerestAndRoyalCare/EmerestQuickGuide.jpg"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        {/* Vertical Image */}
        <div className="col-span-1 sm:col-span-1 lg:col-span-2 row-span-1 bg-gray-100 rounded-2xl overflow-hidden shadow-md sm:col-span-2 ">
          <img
            src="../Imgs/EmerestAndRoyalCare/IMG_6453.jpg"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        {/* Vertical Image  after image 2*/}
        <div className="col-span-1 sm:col-span-1 lg:col-span-2 row-span-1 bg-gray-100 rounded-2xl overflow-hidden shadow-md sm:col-span-2 ">
          <img
            src="../Imgs/EmerestAndRoyalCare/IMG_1392.jpg"
            alt=""
            className="w-full h-full object-fit"
          />
        </div>

        {/* Vertical Image */}
        <div className="col-span-1 sm:col-span-1 lg:col-span-2 row-span-1 bg-gray-100 rounded-2xl overflow-hidden shadow-md sm:col-span-2 ">
          <img
            src="../Imgs/EmerestAndRoyalCare/IMG_1395.jpg"
            alt=""
            className="w-full h-full object-fit"
          />
        </div>

        {/* Vertical Image */}
        <div className="col-span-1 sm:col-span-1 lg:col-span-2 row-span-1 bg-gray-100 rounded-2xl overflow-hidden shadow-md sm:col-span-2 ">
          <img
            src="../Imgs/EmerestAndRoyalCare/IMG_1396.jpg"
            alt=""
            className="w-full h-full object-fit"
          />
        </div>

        {/* Vertical Image */}
        <div className="col-span-1 sm:col-span-1 lg:col-span-2 row-span-1 bg-gray-100 rounded-2xl overflow-hidden shadow-md sm:col-span-2 ">
          <img
            src="../Imgs/EmerestAndRoyalCare/RoyalCare.jpg"
            alt=""
            className="w-full h-full object-fit"
          />
        </div>

        {/* Horizontal Text Box - Move this BELOW the first horizontal image to appear on second row
        <div className=" col-span-1 sm:col-span-1 lg:col-span-2 row-span-1 bg-gray-100 rounded-2xl shadow-md sm:col-span-2 flex items-center justify-center text-center">
          <div>
            <h1 className="text-royalBlue text-4xl pt-2 font-semibold">
              Behind the Scenes 👇 👉
            </h1>
            <p className="text-m text-gray-800"></p>
          </div>
        </div>
        {/* Vertical Image */}
        <div className="col-span-1 sm:col-span-1 lg:col-span-2 row-span-1 bg-gray-100 rounded-2xl overflow-hidden shadow-md sm:col-span-2 ">
          <img
            src="../Imgs/EmerestAndRoyalCare/Royal Care pic web.jpg"
            alt=""
            className="w-full h-full object-fit"
          />
        </div>

        {/* Vertical Image */}
        {/* <div className="col-span-1 sm:col-span-1 lg:col-span-2 row-span-2 bg-gray-100 rounded-2xl overflow-hidden shadow-md sm:col-span-2 ">
          <img
            src="../Imgs/EmerestAndRoyalCare/btsRoyalCarePhotoshoot.jpg"
            alt=""
            className="w-full h-full object-fit"
          />
        </div> */}

        {/* Horizontal Image */}
        {/* <div className="col-span-1 sm:col-span-2 lg:col-span-2 row-span-2 bg-black rounded-2xl overflow-hidden shadow-md">
          <img
            src="../Imgs/EmerestAndRoyalCare/BehindTheScenesRoyal.jpg"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>  */}
      </div>
    </div>
  );
}
